import { render } from "./still-image.vue?vue&type=template&id=5bc60eeb"
import script from "./still-image.js?vue&type=script&lang=js"
export * from "./still-image.js?vue&type=script&lang=js"

import "./still-image.vue?vue&type=style&index=0&id=5bc60eeb&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__